import { SpecialProjectTimeOption } from "../interfaces";

export const timeOptions: SpecialProjectTimeOption[] = [
  {
    id: "hour",
    name: "Per Hour",
    label: "Hour",
  },
];

type TimeOptionsMap = Record<string, SpecialProjectTimeOption>;
export const timeOptionsMap: TimeOptionsMap = timeOptions.reduce((obj, option) => {
  obj[option.id] = option;
  return obj;
}, {} as TimeOptionsMap);
